export const environment = {
  backendUrl: 'https://fsm-dev-api.splash.tech',
  jackpotSDKUrl: 'https://jackpot-lib-dev.splash.tech/splash-jackpots.js',
  hubFrontendUrl: 'http://localhost:4204',
  jackpotFrontendUrl: 'https://jackpot-dev.splash.tech',
};
